//Index Imports
import Pages from "./Pages";

//Merge Index
const Routes = [...Pages];

export { Routes };